import React, { Fragment } from "react";

const Body = ({ renderField, renderDateField, renderFlags, ...props }) => {
    const { carIds, from, to, intCalculateFlags } = props;
    return (
        <Fragment>
            {renderField(carIds)}
            {renderDateField(from)}
            {renderDateField(to)}
            {renderFlags(intCalculateFlags)}
        </Fragment>
    );
};

export default Body;
